import React from 'react';

import { RadioGroup } from '@progress/kendo-react-inputs';

const BobRadioGroup = ({
    color,
    data,
    layout,
    onChange,
    value,
    ...props
}) => {

    return (
        <React.Fragment>
            {
                color ?
                    <style>
                        {`
                            .k-radio:checked, .k-radio.k-checked { border-color: ${color}; color: ${color}; background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 12 12'%3e%3ccircle cx='50%25' cy='50%25' r='4' fill='${color}'/%3e%3c/svg%3e"); }                     
                        ` }
                    </style>
                    :
                    null
            }
            <RadioGroup 
                data={data} 
                layout={layout} 
                onChange={onChange} 
                value={value} 
            />
        </React.Fragment>
    );
};

export default BobRadioGroup;
